var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center gap-2 rounded-md text-white text-xs bg-grey-1 h-10 px-3"},[_c('img',{staticClass:"h-6",attrs:{"src":require(`@/assets/logo/abx.png`)}}),_c('span',{staticClass:"text-nowrap"},[_vm._v("HIN: "+_vm._s(_vm.hin))])])
}
var staticRenderFns = []

export { render, staticRenderFns }